export const stages = {
    dataGeneration: {
      title: '📊 Data Generation & Storage',
      infrastructure: ['webScraper', 'database', 'dataLake', 'dataWarehouse', 'dataLakehouse', 'iotSensor', 'socialMediaMonitor', 'thoughtPoliceScanner'],
      actions: [
        {
          id: 'collectRawData',
          text: 'Collect Raw Data (+1)',
          handler: 'collectRawData',
          visible: true,
          tooltip: 'Manually collect 1 raw data point\nCost: Free\nUse: Early game income or feed to data processing'
        },
        {
          id: 'sellRawData',
          text: 'Sell Raw Data (+$0.5)',
          handler: 'sellRawData',
          visible: true,
          tooltip: 'Sell 1 raw data for $0.5\nRequires: 1 raw data in storage\nUse: Quick cash from unprocessed data'
        }
      ]
    },
    dataProcessing: {
      title: '🧹 Data Processing',
      infrastructure: ['dataCleaner', 'etlPipeline', 'streamingSystem', 'cleanDataApi'],
      actions: [
        {
          id: 'cleanData',
          text: 'Clean Data (+1)',
          handler: 'cleanData',
          requiresUpgrade: true,
          upgradeRequired: 'dataCleaning',
          tooltip: 'Convert 1 raw data to 1 clean data\nRequires: Data Cleaning upgrade + 1 raw data\nUse: Process data for better value and ML'
        },
        {
          id: 'sellCleanData',
          text: 'Sell Clean Data (+$1)',
          handler: 'sellCleanData',
          requiresUpgrade: true,
          upgradeRequired: 'dataCleaning',
          tooltip: 'Sell 1 clean data for $1\nRequires: Data Cleaning upgrade + 1 clean data\nUse: Better income than raw data'
        }
      ]
    },
    learning: {
      title: '🧠 Learning',
      infrastructure: ['featureStore', 'featurePipeline', 'trainingPipeline', 'modelRegistry', 'modelApi'],
      actions: []
    },
    consciousness: {
      title: '🌟 Consciousness',
      infrastructure: ['reasoningInferenceStorage', 'agiCluster'],
      actions: []
    }
  };
